import { useEffect } from "react";
import { useMap } from "react-leaflet";

export default function PopupAutoPanFix() {
    const map = useMap();

    useEffect(() => {
        const handleOpen = (e) => {
            const popup = e.popup;
            if (!popup) return;

            // Pan the map so the popup is fully inside the view
            map.panInside(popup.getLatLng(), {
                paddingTopLeft: [10, 180], 
                paddingBottomRight: [0, 40],
                animate: true
            });
        };

        map.on("popupopen", handleOpen);

        return () => {
            map.off("popupopen", handleOpen);
        };
    }, [map]);

    return null;
}
